export const baseTrioDeck = Array.from({ length: 12 }, (_, number) => {
    const value = number + 1;
    return [value, value, value];
}).flat();

export const buildTrioDeck = () => {
    return [...baseTrioDeck].sort(() => Math.random() - 0.5);
};
